__turbopack_context__.v({
  "contentsRoot": "Contents-module__JaPN0W__contentsRoot",
  "wrapper": "Contents-module__JaPN0W__wrapper",
});
